import { StaffPersona } from "@features/personas/components/StaffPersona"
import { Card, Stack, Group, Text } from "@mantine/core"
import { useCourseNavigation, useCourseNavigationEnabled } from "@features/course-overview/useCourseNavigation"
import { CurrentLesson as CurrentLessonType } from "@godalming/api-types"

export const CurrentLesson: React.FC<{ lesson: CurrentLessonType | null }> = ({ lesson }) => {

    const openCourse = useCourseNavigation()
    const courseNavigationEnabled = useCourseNavigationEnabled()

    if (!lesson) {
        return (
            <Card withBorder className={'h-fit!'}>
                <Card.Section px={6} py={3} inheritPadding>
                    <Group gap={5}>
                        <div className={'size-2 rounded-full'} style={{ backgroundColor: 'light-dark(var(--mantine-color-gray-6), var(--mantine-color-dark-3))' }} />
                        <Text size="xs" c={'dimmed'}>Current lesson</Text>
                    </Group>
                </Card.Section>
                <Card.Section p={'xs'} pt={0}>
                    <Text size="xs" fw={400} c="dimmed">Not in a lesson right now</Text>
                </Card.Section>
            </Card>
        )
    }

    return (
        <Card 
            withBorder 
            className={`${courseNavigationEnabled ? 'cursor-pointer transition-all duration-200 hover:shadow-xs!' : ''} shadow-none! h-fit!`}
            onClick={courseNavigationEnabled ? (e) => {
                e.preventDefault()
                e.stopPropagation()
                if (lesson.idClass != null) openCourse({ type: "class", id: lesson.idClass.toString() })
            } : undefined}
        >
            <Card.Section px={6} py={3} inheritPadding>
                <Group gap={5}>
                    <div className={'size-2 rounded-full'} style={{ backgroundColor: 'var(--mantine-color-red-6)' }} />
                    <Text size="xs" c={'dimmed'}>Current lesson</Text>
                </Group>
            </Card.Section>
            <Card.Section p={'xs'} pt={0}>
                <Stack gap={2}>
                    <Text size="xs" fw={500}>{lesson.subjectName}</Text>
                    {lesson.roomCode ? <Text size="xs" >Room {lesson.roomCode}</Text> : null}
                    {lesson.initials && lesson.initials !== 'NONE' ? <StaffPersona identifier={{ type: 'initials', value: lesson.initials }} textProps={{ size: 'xs', fw: 400 }} avatarProps={{ size: 16 }}/> : null}
                </Stack>
            </Card.Section>
        </Card>
    )
}
